import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { CookieDimType, MeasuredCookieType, Dims, ServerCookies } from './types';

export const updateMeasuredCookie = createAction(
  `${actionKey}/UPDATE_COOKIE`,
  (cookieType: MeasuredCookieType, cookieDim: CookieDimType, dims: Dims) => ({
    cookieType,
    cookieDim,
    dims,
  })
);

export const initializeMeasuredCookie = createAction(
  `${actionKey}/INIT`,
  (cookies: ServerCookies) => ({ cookies })
);
